var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-liveLogo"},[_c('img',{attrs:{"src":(_vm.assetsUrl + "img/newlogo.png"),"alt":"A-live"}})])}
var staticRenderFns = []

export { render, staticRenderFns }